import { keepValueUnchanged } from '../../field-viewer/shared-normalizers';
export const challengesFileUploadViewer = {
    normalizeLoadedValue: keepValueUnchanged
};

//# sourceMappingURL=definition-viewer.js.map